import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  permitTemplatesKeys,
  RequestTypes,
} from '@core/react-query/features/templates/permitTemplates'
import { IPermitTemplateRole } from '@core/entities/permit/PermitTemplateRoles'

export const useCreatePermitTemplateRole = (
  options?: UseMutationOptions<
    IPermitTemplateRole,
    RequestErrorType,
    RequestTypes['createPermitRole']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...permitTemplatesKeys.createPermitRole,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: permitTemplatesKeys.getRoles({
          templateId: variables.templateId,
          templateVersionId: variables.templateVersionId,
        }).queryKey,
      })
    },
    ...options,
  })
}
